// Copyright (c) 2019 Deere & Company

import actions from '../../action-list';

export const updateIsEditable = isEditable => ({
    isEditable,
    type: actions.UPDATE_CLAIM_WEAR_PARTS_IS_EDITABLE
});



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-creators/is-editable.js